var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,18.3h-1.5V9.5C19.5,5.3,16.1,2,12,2S4.5,5.3,4.5,9.5v8.8H3c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h5.8 C9.1,20.8,10.4,22,12,22s2.9-1.2,3.2-2.7H21c0.3,0,0.5-0.2,0.5-0.5C21.5,18.5,21.3,18.3,21,18.3z M5.5,18.3V9.5C5.5,5.9,8.4,3,12,3 s6.5,2.9,6.5,6.5v8.8H5.5z M12,21c-1,0-1.9-0.7-2.2-1.7h4.3C13.9,20.3,13,21,12,21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.3d3602fd990fe2722d334af1e1345926.svg";
export { ForwardRef as ReactComponent };